import styled from 'styled-components'

export const Tabs = styled.div`
  .panes {
    border-bottom: 2px solid ${ (props) => props.theme.colors.grau2 };
    height: 60px;
  }

  .tab-content {
    padding: 32px 0 0;
  }
`
